export default {
  'Text': 'Tekst',
  'Styles': 'Stijlen',
  'Text here': 'Tekst hier',
  'Add subtitles': 'Tekst toevoegen',
  'Text Color': 'Tekst kleur',
  'Outline': 'Outline',
  'Background': 'Achtergrond',
  'Position': 'Positie',
}